<template>
  <div class="gestion-categorias-container p-4">
    <div class="mb-3">
      <vs-button icon="arrow_back" size="small" type="border" @click="$router.push('/actividades-control')">Volver</vs-button>
    </div>
    <vx-card title="Gestión de Categorías">
      <!-- Selector de departamento -->
      <div class="flex items-center gap-4 mb-6">
        <div class="w-full md:w-1/3">
          <label class="text-sm font-semibold">Departamento</label>
          <v-select
            v-model="tdpId"
            :options="departamentos"
            :reduce="opt => opt.tdp_id"
            label="tdp_nombre"
            @input="cargarCategorias"
            placeholder="Seleccionar departamento"
            class="w-full"
          />
        </div>
        <vs-button v-if="tdpId" @click="abrirNueva" color="primary" icon="add">Nueva Categoría</vs-button>
      </div>

      <!-- Grid de categorías -->
      <div v-if="tdpId && cargando" class="flex justify-center py-12">
        <vs-spinner />
      </div>

      <div v-if="tdpId && !cargando && categorias.length === 0" class="text-center py-12 text-gray-500">
        <i class="feather icon-folder text-4xl mb-3" style="opacity: 0.5;"></i>
        <p>No hay categorías en este departamento. Crea la primera.</p>
      </div>

      <div v-if="tdpId && !cargando && categorias.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          v-for="cat in categorias"
          :key="cat.id_categoria"
          class="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white"
        >
          <div class="flex items-start justify-between">
            <div class="flex items-center gap-3 flex-1 min-w-0">
              <div
                class="w-10 h-10 rounded-lg flex-shrink-0"
                :style="{ backgroundColor: cat.color }"
              ></div>
              <div class="min-w-0">
                <h5 class="font-bold truncate">{{ cat.nombre_categoria }}</h5>
                <p class="text-sm text-gray-600 truncate">{{ cat.descripcion }}</p>
              </div>
            </div>
            <div class="flex gap-2">
              <vs-button size="small" icon="edit" @click="editar(cat)" color="warning" type="flat" />
              <vs-button size="small" icon="delete" @click="eliminar(cat.id_categoria)" color="danger" type="flat" />
            </div>
          </div>
        </div>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarForm" class="mt-6 border-t pt-6">
        <h5 class="font-bold mb-4">{{ form.id_categoria ? 'Editar' : 'Nueva' }} Categoría</h5>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="text-sm font-semibold">Nombre *</label>
            <vs-input v-model="form.nombre_categoria" class="w-full" placeholder="Ej: Desarrollo Backend" />
          </div>
          <div>
            <label class="text-sm font-semibold">Color</label>
            <input v-model="form.color" type="color" class="w-full h-10 border rounded" />
          </div>
          <div class="md:col-span-2">
            <label class="text-sm font-semibold">Descripción</label>
            <vs-textarea v-model="form.descripcion" class="w-full" rows="2" placeholder="Describe el tipo de actividades..." />
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <vs-button @click="cancelar" color="warning">Cancelar</vs-button>
          <vs-button @click="guardar" color="success">{{ form.id_categoria ? 'Actualizar' : 'Crear' }}</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'GestionCategorias',
  data() {
    return {
      tdpId: null,
      departamentos: [],
      categorias: [],
      cargando: false,
      mostrarForm: false,
      form: {
        id_categoria: null,
        nombre_categoria: '',
        descripcion: '',
        color: '#3b82f6'
      }
    }
  },
  mounted() {
    this.cargarDepartamentos()
  },
  methods: {
    async cargarDepartamentos() {
      try {
        const res = await this.$http.get(this.$server_url + 'actividades-control/departamentos')
        this.departamentos = res.data
      } catch (e) {
        console.error(e)
      }
    },
    async cargarCategorias() {
      if (!this.tdpId) return
      this.cargando = true
      try {
        const res = await this.$http.get(this.$server_url + `actividades-control/categorias/${this.tdpId}`)
        this.categorias = res.data
      } catch (e) {
        console.error(e)
        this.$vs.notify({ title: 'Error', text: 'No se pudieron cargar categorías', color: 'danger' })
      } finally {
        this.cargando = false
      }
    },
    abrirNueva() {
      this.form = { id_categoria: null, nombre_categoria: '', descripcion: '', color: '#3b82f6' }
      this.mostrarForm = true
    },
    editar(cat) {
      this.form = { ...cat }
      this.mostrarForm = true
    },
    cancelar() {
      this.mostrarForm = false
      this.form = { id_categoria: null, nombre_categoria: '', descripcion: '', color: '#3b82f6' }
    },
    async guardar() {
      if (!this.form.nombre_categoria) {
        this.$vs.notify({ title: 'Atención', text: 'El nombre es obligatorio', color: 'warning' })
        return
      }
      try {
        const payload = { tdp_id: this.tdpId, ...this.form }
        if (this.form.id_categoria) {
          await this.$http.put(this.$server_url + `actividades-control/categorias/${this.form.id_categoria}`, payload)
          this.$vs.notify({ title: 'Éxito', text: 'Categoría actualizada', color: 'success' })
        } else {
          await this.$http.post(this.$server_url + 'actividades-control/categorias', payload)
          this.$vs.notify({ title: 'Éxito', text: 'Categoría creada', color: 'success' })
        }
        this.cancelar()
        this.cargarCategorias()
      } catch (e) {
        console.error(e)
        this.$vs.notify({ title: 'Error', text: 'No se pudo guardar', color: 'danger' })
      }
    },
    async eliminar(id) {
      if (!await this.$vs.confirm('¿Eliminar esta categoría?')) return
      try {
        // El endpoint DELETE no existe en API, notificar
        this.$vs.notify({ title: 'Info', text: 'Endpoint DELETE pendiente en API', color: 'warning' })
      } catch (e) {
        this.$vs.notify({ title: 'Error', text: 'No se pudo eliminar', color: 'danger' })
      }
    }
  }
}
</script>